import { render } from "./dashboard.vue?vue&type=template&id=20c1c997&scoped=true"
import script from "./dashboard.js?vue&type=script&lang=js&external"
export * from "./dashboard.js?vue&type=script&lang=js&external"

import "./dashboard.css?vue&type=style&index=0&id=20c1c997&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c1c997"]])

export default __exports__